import React from 'react';
import logo from 'images/panel/microzync.png';
import { useGlobalState } from 'resources/GlobalStateContext';

const Soporte = () => {
    const { setGlobalTitulo } = useGlobalState();

    React.useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Soporte',
            subtitulo: ''
        }));
    }, [setGlobalTitulo]);

    return (
        <div className='container-fluid p-2 p-md-4'>
            <div className='card p-3 p-md-4' style={{ width: '100%', boxSizing: 'border-box' }}>
                <div className='row justify-content-center text-center'>
                    <div className='col-12 col-md-10 col-lg-8'>
                        <h2 className='mt-2'>¿Necesitas Ayuda?</h2>

                        <div className='mt-3 mb-4' style={{ wordBreak: 'break-word' }}>
                            <h4 className='mb-3'>Para dudas o soporte, por favor comunícate a:</h4>
                            <h5 className='mb-2'>Tel. +52 1 951 463 1953</h5>
                            <h5 className='mb-2'>
                                Email: <a href='mailto:soporte@microzync.com'>soporte@microzync.com</a>, <a href='mailto:soporte@atti.com.mx'>soporte@atti.com.mx</a>
                            </h5>
                            <h5 className='mb-3'>Whatsapp: +52 1 951 463 1953</h5>
                            <div>
                                <a href='https://anydesk.com/es/downloads/windows' target='_blank' rel='noreferrer'>
                                    Descargar anydesk
                                </a>
                            </div>
                        </div>

                        <div className='d-flex justify-content-center align-items-center mt-2'>
                            <img
                                src={logo}
                                alt='logo'
                                className='img-fluid'
                                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Soporte };